import { routerMiddleware } from 'connected-react-router';
import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from './reducers/rootReducer';
import { redirectMiddleware } from './middleware/redirectMiddleware';
import { apiUrlMiddleware } from './middleware/apiUrlMiddleware';
import { nextTaskMiddleware } from './middleware/nextTaskMiddleware';
import { history } from './routes';

function createAppStore(preloadedState) {
  const store = configureStore({
    reducer: rootReducer(history),
    preloadedState,
    middleware: (getDefaultMiddleware) => {
      return [
        ...getDefaultMiddleware({
          immutableCheck: false,
          serializableCheck: false
        }),
        routerMiddleware(history),
        redirectMiddleware,
        apiUrlMiddleware,
        nextTaskMiddleware
      ];
    },
    devTools: { name: 'Personal Loans | Virgin Money UK' }
  });

  if (process.env.NODE_ENV !== 'production') {
    if (module.hot) {
      module.hot.accept('./reducers/rootReducer', () => store.replaceReducer(rootReducer(history)));
    }
  }
  return store;
}

export { createAppStore };
